const LocaleService = require('services/locale-service');
const BlockView = require('views/block/base-block-view');
const AhoyService = require('services/ahoy-service');

const ButtonView = BlockView.extend({
  className: 'buttons',
  initialize: function () {
    BlockView.prototype.initialize.apply(this, arguments);
    this.autoComplete = true;
    this.completed = false;
    this.model.set('cid', this.model.cid);
    var buttons = this.model.get('buttons');
    var button = {
      id: this.model.get('id'),
      class: this.model.get('class'),
      text: this.model.get('text'),
    };

    if (this.model.get('text') && !this.model.get('initialized')) {
      this.model.set('initialized', true);
      if (buttons) {
        buttons.unshift(button);
      } else {
        buttons = [button];
        this.model.set('buttons', buttons);
      }
    }

    const self = this;
    this.model.get('buttons').forEach(function (button, i) {
      switch (button.action_type) {
        case 'open_modal':
          button.attributes = self.createSafeString('data-toggle=modal data-target=#', button.modal_id);
          break;
        case 'navigate':
          button.attributes = self.createSafeString('data-navigate=', button.direction);
          break;
        case 'action':
          button.attributes = new Handlebars.SafeString(
            `data-action=${button.action} data-target=#${button.target_id}`
          );
          break;
        default:
          break;
      }
      if (button.path && !(button.path instanceof Handlebars.SafeString) && button.path.substring(0, 1) !== '#') {
        button.path = self.createSafeString('#', LocaleService.t(button.path));
      }
    });

    this.delegate('click', function (e) {
      const button_clicked = e.target;
      Chaplin.mediator.publish(
        'button:clicked',
        {
          buttonId: button_clicked.id,
          target: $(button_clicked).data('target'),
          action: $(button_clicked).data('action'),
        },
        this,
        self.pageView
      );
    });
  },
  load: function () {
    var self = this;
    _.each(this.model.get('buttons'), function (button, i) {
      self.renderChildAriaProperties(button, i);
    });
    this.delegate('click', '[data-navigate]', function (e) {
      e.preventDefault();
      var navigateType = $(e.currentTarget).attr('data-navigate');
      AhoyService.track('button', { action: 'navigate', target: navigateType });
      Chaplin.mediator.publish('page:navigate', navigateType);
    });
    this.renderMultipleNestedBlocks('buttons');
  },
  createSafeString: function (safeString, unsafeString) {
    return new Handlebars.SafeString(safeString + Handlebars.Utils.escapeExpression(unsafeString));
  },
  play: function () {
    if (this.autoComplete) {
      this.completed = true;
      this.readyToGo();
    }
  },
});

module.exports = ButtonView;
